const RANKING = [
  { rank: 1, title: '鬼灭之刃 无限城篇', type: '热血', status: '今日更新', hot: true },
  { rank: 2, title: '咒术回战', type: '热血', status: '今日更新', hot: true },
  { rank: 3, title: '海贼王', type: '冒险', status: '昨日更新', hot: false },
  { rank: 4, title: '间谍过家家', type: '喜剧', status: '2天前更新', hot: true },
  { rank: 5, title: '坂本日常', type: '动作', status: '今日更新', hot: false },
  { rank: 6, title: '怪兽8号', type: '科幻', status: '昨日更新', hot: true },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-10">
          <div className="w-10 h-10 rounded-xl bg-accent-100 flex items-center justify-center">
            <i className="ri-trophy-line text-accent-600 text-xl"></i>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">人气榜单</h2>
        </div>

        <div className="bg-background-50 border border-background-200 rounded-2xl overflow-hidden">
          <div className="hidden sm:grid grid-cols-12 gap-4 px-6 py-3.5 text-xs font-semibold text-foreground-400 uppercase tracking-wider border-b border-background-200 bg-background-100/50">
            <div className="col-span-1">排名</div>
            <div className="col-span-5">作品名称</div>
            <div className="col-span-2">类型</div>
            <div className="col-span-3">更新状态</div>
            <div className="col-span-1">热度</div>
          </div>

          {RANKING.map((item) => (
            <div
              key={item.rank}
              className="grid grid-cols-1 sm:grid-cols-12 gap-2 sm:gap-4 px-4 sm:px-6 py-4 items-center border-b border-background-100 last:border-b-0 hover:bg-primary-50/20 transition-colors cursor-pointer"
            >
              <div className="sm:col-span-1 flex items-center gap-3 sm:gap-0">
                <span
                  className={`w-7 h-7 rounded-lg flex items-center justify-center text-xs font-bold ${
                    item.rank <= 3
                      ? 'bg-accent-500 text-background-50'
                      : 'bg-background-200 text-foreground-500'
                  }`}
                >
                  {item.rank}
                </span>
                <span className="sm:hidden font-semibold text-sm text-foreground-800">{item.title}</span>
              </div>
              <div className="hidden sm:block sm:col-span-5">
                <span className="font-semibold text-sm text-foreground-800">{item.title}</span>
              </div>
              <div className="sm:col-span-2">
                <span className="text-xs font-medium text-secondary-600 bg-secondary-100 px-2.5 py-1 rounded-md whitespace-nowrap">
                  {item.type}
                </span>
              </div>
              <div className="sm:col-span-3">
                <span className="text-xs text-foreground-500">{item.status}</span>
              </div>
              <div className="sm:col-span-1">
                {item.hot && (
                  <span className="inline-flex items-center gap-1 text-xs font-semibold text-accent-600">
                    <i className="ri-fire-line"></i>
                    HOT
                  </span>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}